<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item has-arrow has-droprdown">
            <router-link v-bind:to="{ name: 'Tasks' }" v-bind:class="activeMenu">
                <md-icon class="arrow-icon-right" @click.prevent.stop.native="$root.toggleMenu($event)">keyboard_arrow_right</md-icon>
                <md-icon class="arrow-icon-down"  @click.prevent.stop.native="$root.toggleMenu($event)">keyboard_arrow_down</md-icon>
                <md-icon>assignment_turned_in</md-icon>
                <span>Задачи</span>
            </router-link>

            <!-- Projects -->
            <ul v-if="projects.length" class="main-menu__submenu">
                <li
                    v-for="project in projects"
                    v-bind:key="`tasks-menu-project-${project.id}`"
                    class="main-menu__item has-arrow has-droprdown"
                >
                    <a class="action-link">
                        <md-icon
                            v-if="project.tasks_status && project.tasks_status.length"
                            @click.prevent.stop.native="$root.toggleMenu($event)"
                            class="arrow-icon-right"
                        >keyboard_arrow_right</md-icon>
                        <md-icon
                            v-if="project.tasks_status && project.tasks_status.length"
                            @click.prevent.stop.native="$root.toggleMenu($event)"
                            class="arrow-icon-down"
                        >keyboard_arrow_down</md-icon>
                        <span>{{ project.name }}</span>
                        <md-menu md-size="medium">
                            <md-button class="small md-icon-button md-dense" md-menu-trigger @click.prevent.stop="">
                                <md-icon>more_horiz</md-icon>
                                <md-menu-content md-theme="white">
                                    <md-menu-item @click="openProjectEditDialog(project)"><span>Изменить</span></md-menu-item>
                                    <md-menu-item @click="openProjectDeleteDialog(project)"><span>Удалить</span></md-menu-item>
                                    <md-menu-item @click="openStatusAddDialog(project)"><span>Добавить статус</span></md-menu-item>
                                </md-menu-content>
                            </md-button>
                        </md-menu>
                    </a>

                    <!-- Project statuses -->
                    <ul v-if="project.tasks_status && project.tasks_status.length" class="main-menu__submenu can-scroll">
                        <md-divider></md-divider>
                        <li class="main-menu__item" v-for="status in project.tasks_status">
                            <a class="action-link">
                                <span>{{ status.name }}</span>
                                <md-menu md-size="medium">
                                    <md-button
                                        class="small md-icon-button md-dense"
                                        md-menu-trigger
                                        @click.prevent.stop=""
                                    >
                                        <md-icon>more_horiz</md-icon>
                                    </md-button>
                                    <md-menu-content md-theme="white">
                                        <md-menu-item @click="openStatusEditDialog(status)"><span>Изменить</span></md-menu-item>
                                        <md-menu-item @click="openStatusDeleteDialog(status)"><span>Удалить</span></md-menu-item>
                                    </md-menu-content>
                                </md-menu>
                            </a>
                        </li>
                        <md-divider></md-divider>
                    </ul>
                </li>

                <md-divider></md-divider>
            </ul>

            <!-- Tags -->
            <ul class="main-menu__submenu">
                <li class="main-menu__item has-arrow has-droprdown">
                    <a class="action-link">
                        <md-icon class="arrow-icon-right" @click.prevent.stop.native="$root.toggleMenu($event)">keyboard_arrow_right</md-icon>
                        <md-icon class="arrow-icon-down"  @click.prevent.stop.native="$root.toggleMenu($event)">keyboard_arrow_down</md-icon>
                        <span>Теги</span>
                    </a>

                    <ul v-if="groups && groups.length" class="main-menu__submenu can-scroll">
                        <li
                            v-for="group in groups"
                            v-bind:key="`tasks-menu-group-${group.id}`"
                            class="main-menu__item"
                        >
                            <a class="action-link">
                                <span>{{ group.name }}</span>
                                <md-menu md-size="medium">
                                    <md-button class="small md-icon-button md-dense" md-menu-trigger @click.prevent.stop="">
                                        <md-icon>more_horiz</md-icon>
                                    </md-button>
                                    <md-menu-content md-theme="white">
                                        <md-menu-item @click="openGroupEditDialog(group)"><span>Изменить</span></md-menu-item>
                                        <md-menu-item @click="openGroupDeleteDialog(group)"><span>Удалить</span></md-menu-item>
                                    </md-menu-content>
                                </md-menu>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

            <md-divider></md-divider>
        </li>

        <!-- диалог создания/редактирования проекта -->
        <div class="main-menu__tasks__modals">
            <ZDialog v-bind:active.sync="editProjectDialog">
                <div slot="title">{{ editProject.id ? 'Изменить' : 'Создать' }} проект</div>
                <div slot="default">
                    <ZInput
                        label="Название"
                        v-model="editProject.name"
                        v-validate="{required: true, min: 3, max: 255}"
                        name="project-name"
                        data-vv-as=" "
                        data-vv-name="project-name"
                        data-vv-scope="project"
                        v-bind:error="errors.first('project.project-name')"
                    />
                </div>
                <template slot="actions">
                    <ZButton @click="closeProjectDialog" accent>Отмена</ZButton>
                    <ZButton @click="saveProject" primary>Сохранить</ZButton>
                </template>
            </ZDialog>

            <!-- диалог создания/редактирования статуса проекта -->
            <ZDialog v-bind:active.sync="editProjectStatusDialog">
                <div slot="title">{{editStatus.id ? 'Изменить' : 'Создать' }} статус</div>
                <div slot="default">
                    <ZInput
                        label="Название"
                        v-model="editStatus.name"
                        v-validate="{required: true, min: 3, max: 255}"
                        name="status-name"
                        data-vv-as=" "
                        data-vv-name="status-name"
                        data-vv-scope="status"
                        v-bind:error="errors.first('status.status-name')"                        
                    />
                </div>
                <template slot="actions">
                    <ZButton @click="closeStatusEditDialog" accent>Отмена</ZButton>
                    <ZButton @click="saveStatus" primary>Сохранить</ZButton>
                </template>
            </ZDialog>

            <!-- диалог создания/редактирования тега/группы -->
            <ZDialog v-bind:active.sync="editGroupDialog">
                <div slot="title">{{editGroup.id ? 'Изменить' : 'Создать' }} тег</div>
                <div slot="default">
                    <ZInput
                        label="Название"
                        v-model="editGroup.name"
                        v-validate="{required: true, min: 3, max: 255}"
                        name="tag-name"
                        data-vv-as=" "
                        data-vv-name="tag-name"
                        data-vv-scope="tag"
                        v-bind:error="errors.first('tag.tag-name')"                        
                    />
                </div>
                <template slot="actions">
                    <ZButton @click="closeGroupDialog" accent>Отмена</ZButton>
                    <ZButton @click="saveGroup" primary>Сохранить</ZButton>
                </template>
            </ZDialog>
        </div>

    </ul>
</template>
<script>
    import ZDialog from './../../../components/ZDialog.vue';
    import ZInput  from './../../../components/ZInput.vue';
    import ZButton from './../../../components/ZButton.vue';
    export default {
        name: 'tasks-main-menu',
        sort: 1,
        module: 'tasks',
        components: { ZDialog, ZInput, ZButton },
        created() {
            this.init();
            this.listeners();
        },
        computed: {
            groups() {
                if (!this.$store.state || !this.$store.state.tasks || !this.$store.state.tasks.groups) return []
                return this.$store.state.tasks.groups.data;
            },
            activeMenu() {
                let routes = ['Tasks', 'Task'];
                return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
            }
        },
        data() {
            return {
                module: 'tasks',

                editProjectDialog: false,
                editGroupDialog: false,
                editProjectStatusDialog: false,

                projects: [],
                addProject: {
                    name: ''
                },
                editProject: {
                    name: ''
                },
                editGroup: {
                    name: ''
                },
                editStatus: {
                    name: '',
                    project_id: null
                },
                deleteStatus: {},

                oldItem: {},
                itemToDelete: {}
            }
        },
        methods: {
            init() {
                this.getProjects();
                this.getGroups();
            },
            listeners() {
                this.$root.$on('update-task-menu', () => this.init());
            },
            //сохранение проекта
            saveProject() {
                this.$validator.validateAll('project').then(async valid => {
                    if (!valid) return;

                    if (!this.editProject.id) this.$store.dispatch('tasks/addProject', { name: this.editProject.name });
                    else this.$store.dispatch('tasks/updateProject', { project: this.editProject });

                    this.editProjectDialog = false
                    this.oldItem = {}
                    this.editProject = {name: null, group_id: null}
                });
            },
            //открытие диалога удаления проекта
            openProjectDeleteDialog(item) {
                if (!item || !item.id) return;
                this.$root.$emit('z-alert', 'Удалить проект?', null, () => {
                    this.$store.dispatch('tasks/deleteProject', { id: item.id })
                });
            },
            //открытие диалога изменения проекта
            openProjectEditDialog(item) {
                this.editProjectDialog = true
                this.editProject = item
                this.oldItem.name = item.name
                this.oldItem.group_id = item.group_id
            },
            closeProjectDialog() {
                this.editProjectDialog = false
                this.editProject.name = this.oldItem.name
                this.editProject.group_id = this.oldItem.group_id
                this.oldItem = {}
                this.editProject = {
                    name: '',
                    group_id: ''
                }
            },
            openStatusEditDialog(status) {
                this.editStatus = Object.assign({}, status);
                this.editProjectStatusDialog = true;
            },
            closeStatusEditDialog() {
                this.editStatus = {name: '', project_id: null};
                this.editProjectStatusDialog = false;
            },
            openStatusDeleteDialog(item) {
                if (!item || !item.id) return;
                this.$root.$emit('z-alert', 'Удалить статус?', null, () => {
                    this.$store.dispatch('tasks/deleteProject', { id: item.id })
                });
            },
            openStatusAddDialog(project) {
                this.editStatus = Object.assign({}, {name: '', project_id: project.id});
                this.editProjectStatusDialog = true;
            },
            saveStatus() {
                this.$validator.validateAll('status').then(async valid => {
                    if (!valid || !this.editStatus.project_id) return;
                    if (this.editStatus.id) this.$store.dispatch('tasks/updateStatus', { status: this.editStatus });
                    else this.$store.dispatch('tasks/addStatus', {status_name: this.editStatus.name, project_id: this.editStatus.project_id});
                    this.editProjectStatusDialog = false;
                    this.editStatus = {name: null, project_id: null}
                });
            },
            //сохранение тега/группы
            saveGroup() {
                this.$validator.validateAll('status').then(async valid => {
                    if (!valid) return;
                    this.editGroupDialog = false
                    this.$store.dispatch('tasks/updateGroup', { group: this.editGroup });
                    this.oldItem = {}
                    this.editGroup = {name: null}
                });
            },
            //открытие диалога удаления тега/группы
            openGroupDeleteDialog(item) {
                if (!item || !item.id) return;
                this.$root.$emit('z-alert', 'Удалить тег?', null, () => {
                    this.$store.dispatch('tasks/deleteGroup', { group_id: item.id });    
                });
            },
            //открытие диалога изменения тега/группы
            openGroupEditDialog(item) {
                this.editGroupDialog = true
                this.editGroup = item
                this.oldItem.name = item.name
            },
            closeGroupDialog() {
                this.editGroupDialog = false
                this.editGroup.name = this.oldItem.name
                this.oldItem = {}
                this.editGroup = { name: null }
            },
            getProjects() {
                return this.$store.dispatch('tasks/getProjects').then(r => {
                    if (r && r.length) this.projects = Object.assign([], r);
                    else this.projects = [];
                    return this.projects;
                });
            },
            getGroups() {
                return this.$store.dispatch('tasks/getAllGroups', {order_by: 'id', order_type: 'asc', count: 'all'});
            }
        },
        watch: {
            '$store.state.users.current'() {
                this.getGroups();
            }
        }
    }
</script>
<style lang="sass">
#app
    .tasks-menu
        .tags-menu-main
        .tags-menu
            max-height: 200px
            overflow-y: auto
            a
                padding-left: 40px !important
                padding: 0px 10px 0px 40px
                min-height: 30px !important
        .status-menu
            max-height: 200px
            overflow-y: auto
            .item
                .status
                    padding-left: 60px !important
                    padding: 0px 10px 0px 40px
                    min-height: 30px !important
                    
</style>


// WEBPACK FOOTER //
// MainMenu.vue?0c1d2f00